import api from './api';

/**
 * Call the backend logout endpoint to deactivate the server-side session.
 * This must be called before clearing local MSAL state.
 */
export async function logoutBackend(): Promise<void> {
  await api.post('/auth/logout');
}
